import styled, {css} from 'styled-components';

import {NewNotifications as BaseNewNotifications} from '@edna/components';

export const Link = styled.a<{hasLeftMargin?: boolean}>`
  font-weight: 500;
  color: currentColor;
  margin-left: ${({hasLeftMargin, theme}) => (hasLeftMargin ? theme.spacing.s1 : 0)};
  text-decoration: underline;
`;

type TNotificationsProps = {
  width: string;
  left: string;
  hasSystemNotifications?: boolean;
};

export const Notifications = styled(BaseNewNotifications)<TNotificationsProps>`
  ${({left, width, hasSystemNotifications, theme}) => css`
    left: ${left};
    width: ${width};
    max-width: 100%;
    margin-bottom: ${hasSystemNotifications ? theme.spacing.s4 : 0};
    transition:
      left ${theme.animation.duration}ms ease-in-out,
      top ${theme.animation.duration}ms ease-in-out;
  `}
`;
